import React, {PureComponent} from 'react';
import SkipToContentMenuContext from '../SkipToContentMenuContext';
import SkipToContentMenu from '../SkipToContentMenu/SkipToContentMenu';

class SkipToContentMenuProvider extends PureComponent {
    constructor(props) {
        super(props);

        this.state = {
            isVisible: false,
            menuItems: []
        };
    }

    addMenuItem = (item) => {
        this.setState((state) => {
            const menuItemsByOrder = [...state.menuItems, item].sort((a, b) => a.order - b.order);
            return {
                menuItems: menuItemsByOrder
            };
        });
    }

    removeMenuItem = (id) => {
        this.setState((state) => {
            return {
                menuItems: state.menuItems.filter((i) => i.id !== id)
            };
        });
    }

    render() {
        return (
            <SkipToContentMenuContext.Provider
                value={{
                    addMenuItem: this.addMenuItem,
                    removeMenuItem: this.removeMenuItem
                }}
            >
                <SkipToContentMenu
                    menuTitle={this.props.menuTitle}
                    menuItems={this.state.menuItems}
                    ariaLabel={this.props.ariaLabel}
                />
                {this.props.children}
            </SkipToContentMenuContext.Provider>
        );
    }
}

export default SkipToContentMenuProvider;